var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "training-courses__wrapper" }, [
    _c(
      "div",
      { staticClass: "training-courses" },
      [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSelectedCourse,
              expression: "showSelectedCourse"
            }
          ],
          staticClass: "overlay",
          on: {
            click: function($event) {
              _vm.showSelectedCourse = false
            }
          }
        }),
        _vm._v(" "),
        _vm._l(_vm.modulesData, function(course) {
          return _c(
            "div",
            {
              key: course.id,
              staticClass: "training-courses training-courses__course",
              attrs: { "data-id": course.id }
            },
            [
              _c("div", {
                style:
                  "background: url(" +
                  course.acf.intro_image.sizes.medium +
                  ") no-repeat center center / cover; height: 230px; "
              }),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(course.title.rendered))]),
              _vm._v(" "),
              _c("div", {
                staticClass: "training-courses training-courses__content",
                domProps: {
                  innerHTML: _vm._s(_vm.shorten(course.acf.intro_text))
                }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "elementor-button-link elementor-button elementor-size-sm",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.selectCourse(course)
                    }
                  }
                },
                [_vm._v("See more")]
              ),
              _vm._v(" "),
              _vm.selectedCourse.id == course.id && _vm.showSelectedCourse
                ? _c("div", { staticClass: "training-courses__course--marker" })
                : _vm._e()
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.showSelectedCourse
      ? _c(
          "div",
          {
            staticClass: "training-courses__popup dark_info_sec",
            style: _vm.PopupStyle
          },
          [
            _c(
              "span",
              {
                staticClass: "training-courses__popup--close",
                on: {
                  click: function($event) {
                    _vm.showSelectedCourse = false
                  }
                }
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c("h2", [
              _vm._v(
                _vm._s(_vm.selectedCourse.title.rendered) + " Module Details"
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "training-courses__popupcontentwrapper" },
              [
                _c("div", {
                  staticClass: "image",
                  style:
                    "background: url(" +
                    _vm.selectedCourse.acf.intro_image.sizes.medium_large +
                    ") no-repeat center center / cover"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "training-courses__popupcontent" }, [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.selectedCourse.acf.intro_text)
                    }
                  })
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!./scripts/vue/components/TrainingModules.vue?vue&type=template&id=ccaa7870&
// module id = 109
// module chunks = 3